import Util from '../RegistrationUtil'
import Field from '../RegistrationField'

function Dropdown(opts) {
    Field.call(this, opts)
}

Util.inherit(Dropdown, Field, {
    getClassName: function() {
        return 'dropdown'
    },

    buildHtml: function() {
        var html = '<select id="' + this._getId() + '" >'

        html += '<option value="">' + Util.escape(this.title) + '...' + (this.required ? ' *' : '') + '</option>'

        var list = this.list
        for (var i = 0, ii = list.length; i < ii; ++i) {
            var item = list[i]
            html += '<option value="' + Util.escape(item.value) + '">' + Util.escape(item.label) + '</option>'
        }

        html += '</select>'

        var svg = ''
        if (this.registration.isMaterialUI()) {
            svg = this.registration.getSvg('downArrow2')
        } else {
            svg = this.registration.getSvg('downArrow')
        }
        html += '<div class="svg-icon-wrap">' + svg + '</div>'

        return html
    },

    applyBindings: function() {
        var self = this
        var $select = this.$html.find('select')

        $select.on('change', function() {
            self.setValue($(this).val())
        })
        $select.on('focus', this.focus.bind(this))
        $select.on('blur', this.blur.bind(this))
    },

    updateView: function() {
        Field.prototype.updateView.call(this)

        this.$html.find('select').val(this.value)
    },
})

export default Dropdown
